import { render, staticRenderFns } from "./BigPowerInput.vue?vue&type=template&id=667244bb&scoped=true&"
import script from "./BigPowerInput.vue?vue&type=script&lang=js&"
export * from "./BigPowerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667244bb",
  null
  
)

export default component.exports